module.exports = __webpack_public_path__ + "static/media/close_circle.d1a5ca2d.svg";